import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { CalendarEvent } from '../../models/minutpass/full-calendar-model';

type AppointmentState = {
  refreshRequested?: boolean;
  currentAppointment?: CalendarEvent;
};

const initialAppointmentState: AppointmentState = {
  refreshRequested: false,
  currentAppointment: undefined,
};

@Injectable({
  providedIn: 'root',
})
export class AppointmentStore {
  private readonly appointmentState$ = new BehaviorSubject<AppointmentState>(initialAppointmentState);

  public getRefreshRequested(): Observable<boolean> {
    return this.appointmentState$.pipe(map(data => data.refreshRequested));
  }

  public getCurrentAppointment(): Observable<CalendarEvent> {
    return this.appointmentState$.pipe(map(data => data.currentAppointment));
  }

  public resetCurrentAppointment(): void {
    this.setCurrentAppointment(undefined);
  }

  public setCurrentAppointment(value: CalendarEvent) {
    this.appointmentState$.next({
      currentAppointment: value,
    });
  }

  public requestRefresh() {
    this.appointmentState$.next({
      refreshRequested: !this.appointmentState$.value.refreshRequested,
    });
  }
}
